import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { Button, List, Popconfirm, Result, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth'
import { useAcceptInvitation, useDeclineInvitation } from '../invitation/hooks'
import { Invitation } from '../invitation/invitation'
import { PageTitle } from '../components/page-title'

export const Route = createFileRoute('/_auth/_main/invitations')({
    component: Invitations,
})

export function Invitations() {
    const { t } = useTranslation()
    const { user } = useAuth()

    if (!user?.emailVerifiedAt) {
        return (
            <Result
                status="warning"
                title={t('Invitations disabled')}
                subTitle={t('You can only accept invitations after verifying your email')}
            />
        )
    }
    return (
        <>
            <PageTitle title={t('Invitations')} />
            <List
                dataSource={user?.invitations}
                renderItem={(item) => <InvitationListItem invitation={item} />}
            />
        </>
    )
}

function InvitationListItem({ invitation }: { invitation: Invitation }) {
    const { t } = useTranslation()

    const acceptMutation = useAcceptInvitation(invitation.company.id)
    const declineMutation = useDeclineInvitation(invitation.company.id)

    return (
        <List.Item
            actions={[
                <Button
                    type="primary"
                    loading={acceptMutation.isPending}
                    onClick={() => acceptMutation.mutate()}
                >
                    {t('Accept')}
                </Button>,
                <Popconfirm
                    title={t('Are you sure?')}
                    onConfirm={() => declineMutation.mutate()}
                >
                    <Button
                        danger
                        loading={declineMutation.isPending}
                    >
                        {t('Reject')}
                    </Button>
                </Popconfirm>,
            ]}
        >
            <Typography.Title
                level={4}
                className="mb-0"
            >
                {invitation.company.name}
            </Typography.Title>
        </List.Item>
    )
}
